import ImageInfo from '@/types/ImageInfo';
import Amount from '@/types/Amount';
import ItemInformation from '@/types/ItemInformation';
import { ProductType } from '@/types/ProductType';
import ProductionPeriod from '@/types/ProductionPeriod';
import Tag from '@/types/Tag';
import Price from '@/types/Price';

export default class Item {
    public itemId: string;
    public productId: string;
    public productType: ProductType;
    public originalSticker: boolean;
    public perfectCondition: boolean;
    public quantity: number;
    public itemDescription: Map<string, string>;
    public itemName: Map<string, string>;
    public price: Amount;
    public prices: Price[];
    public percentagePrice: number = 0;
    public iconImage: ImageInfo;
    public images: ImageInfo[];
    public itemInformations: ItemInformation[];
    public productionPeriods: ProductionPeriod[];
    public tags: Tag[];
}
